<template>
  <div v-if="showComponentDecide" class="mt-3">
    <right-panel class="float-right" id="sidebar-info-data-category" width="800px">
      <div class="pl-5 pr-5" v-if="infoItem">
        <h3 class="mb-5">
          <i class="bx bx-info-circle align-middle font-size-24 mr-2"></i>
          <span class="  text-primary">{{ infoItem.name | translate }}</span>

          {{ $t("data-category.info") }}
        </h3>

        <content-loading v-if="isInfoLoading" />
        <div v-else>
          <div v-if="info.docs.length > 0">
            <h5 class="mt-2">{{ $t("data-category.special-quality-data") }}</h5>
            {{ info.docs[0].category.specialQualityData ? $t("common.yes") : $t("common.no") }}
            <h5 class="mt-4">{{ $t("data-category.personal-data") }}</h5>
            {{ info.docs[0].category.personalData ? $t("common.yes") : $t("common.no") }}
            <h5 class="mt-4">{{ $t("data-category.risk-effect-value") }}</h5>
            {{ info.docs[0].category.riskEffectValue }}
          </div>

          <h5 class="mt-4">{{ $t("data-category.used-places") }}</h5>
          <table v-if="info && info.docs.length > 0" class="table table-border table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th>{{ $t("department.text") }}</th>
                <th>{{ $t("process.text") }}</th>
                <th>{{ $t("datasource.text") }}</th>
                <th>{{ $t("data.text") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in info.docs" :key="'info' + i._id">
                <td>
                  {{ i.department.name | translate }}
                </td>
                <td>
                  {{ i.process.name | translate }}
                </td>
                <td>
                  {{ i.datasource.name | translate }}
                </td>
                <td>{{ i.name | translate }}</td>
              </tr>
            </tbody>
          </table>
          <empty v-else width="200px">
            <h6 class="text-center">{{ $t("common.no-hierarchy") }}</h6>
          </empty>
        </div>
        <div v-if="info" class="row">
          <div class="col ">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="infoRequest.options.page" :total-rows="info.totalDocs" :per-page="info.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </right-panel>

    <right-panel class="float-right" id="sidebar-new-data-category" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <!-- Begin : Inventory -->
    <template>
      <right-panel class="float-right" id="sidebar-datacategory-inventory" width="1400px" icon="" @hidden="bulkUpdateRightPanelClosed">
        <BulkUpdateView v-if="selectedBox" @onUpdated="onBulkUpdated" />
      </right-panel>
    </template>
    <!-- End : Inventory -->

    <div class="ds-card">
      <div class="ds-card--title justify-content-between">
        <span>
          <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
          <span
            v-html="
              $t('data-category.owned-list', {
                department: $options.filters.translate(parentEntity.process.department.name),
                process: $options.filters.translate(parentEntity.process.name),
                name: $options.filters.translate(parentEntity.name),
              })
            "
          >
          </span>
        </span>
      </div>
      <div>
        <div class="search2 mb-4" style=" width: 18.50rem;">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination" class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in pagination.docs" :key="item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
          <div class="text">{{ item.name | translate }}</div>
          <div class="actions d-flex justify-content-center">
            <div class="action" @click="fetchInfo(item)" v-on:click.stop v-b-toggle="'sidebar-info-data-category'" v-b-tooltip.hover :title="$t('data-category.used-places')">
              <i class="iconoir-info-circle"></i>
            </div>
            <div class="action" @click="edit(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.edit')">
              <i class="iconoir-edit-pencil"></i>
            </div>
            <div class="action" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
    </div>
  </div>
</template>

<script>
import BulkUpdateView from "@modules/inventory/component/bulk-update/bulk-update-view";
import Form from "../../data/organization-data-category-form";

export default {
  components: { Form, BulkUpdateView },
  data() {
    return {
      nameFilter: undefined,
      request: {
        options: { page: 1, limit: 17, sort: { name: "asc" } },
        query: {},
      },

      infoRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  computed: {
    showComponentDecide() {
      return this.parentEntity; //&& this.pagination?.docs?.length;
    },
    parentEntity() {
      return this.$store.getters["entityBoxes/datasource"];
    },
    pagination() {
      return this.$store.getters["organizationProcessDatasource/datasourceOwnedDataCategoriesPagination"];
    },
    isLoading() {
      return this.$store.getters["organizationProcessDatasource/isDatasourceOwnedDataCategoriesLoading"];
    },
    infoItem() {
      return this.$store.getters["organizationDataCategory/infoItem"];
    },
    info() {
      return this.$store.getters["organizationDataCategory/info"];
    },
    isInfoLoading() {
      return this.$store.getters["organizationDataCategory/isInfoLoading"];
    },
    selectedBox() {
      return this.$store.getters["entityBoxes/dataCategory"];
    },
  },
  watch: {
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    parentEntity(item) {
      this.debounce(() => this.paginate());
    },

    infoRequest: {
      deep: true,
      immediate: false,
      handler() {
        this.debounce(() => this.fetchInfo());
      },
    },
  },
  mounted() {},
  methods: {
    async handleNameFilterChanged(n, o) {
      this.$store.commit("entityBoxes/clearFrom", "dataCategory");
      this.$store.commit("organizationDataCategory/selectedEntity", undefined);

      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedDataCategory = this.$store.getters["entityBoxes/dataCategory"];
        if (selectedDataCategory) {
          await this.selectBox(selectedDataCategory);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    onBulkUpdated() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-datacategory-inventory");
    },

    async showInventoryPanel(item) {
      this.$store.commit("entityBoxes/dataCategory", item);
      this.$store.commit("organizationDataCategory/selectedEntity", item);

      this.$store.commit("inventoryFilter/clear");
      this.$store.commit("inventoryFilter/department", this.$store.getters["entityBoxes/department"]);
      this.$store.commit("inventoryFilter/process", this.$store.getters["entityBoxes/process"]);
      this.$store.commit("inventoryFilter/datasource", this.$store.getters["entityBoxes/datasource"]);
      this.$store.commit("inventoryFilter/dataCategory", item);

      this.$root.$emit("bv::toggle::collapse", "sidebar-datacategory-inventory");
    },

    selectedBoxStyle(item) {
      if (this.selectedBox?._id == item._id) {
        return "bg-main text-white";
      }
    },

    async paginate() {
      if (!this.parentEntity) {
        return;
      }
      await this.$store.dispatch("organizationProcessDatasource/paginateDatasourceOwnedDataCategories", { pagination: this.request, processDatasourceId: this.parentEntity._id });
    },

    selectBox(item) {
      this.$store.dispatch("entityBoxes/selectDataCategory", item);
    },

    edit(item) {
      this.$store.commit("organizationDataCategory/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data-category");
    },
    fetchInfo(item) {
      if (!item) {
        item = this.infoItem;
      }
      this.$store.dispatch("organizationDataCategory/fetchInfo", { item, pagination: this.infoRequest });
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("organizationDataCategory/resetForm");
    },
    bulkUpdateRightPanelClosed() {
      this.$store.commit("inventoryFilter/clear");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../organization-entities-view.scss");
</style>
